const CONTAINER_SELECTOR = '.miraclasFeature__cardMedia--crossfade';
const IMG_SELECTOR = '.miraclasFeature__cardImg';
const ACTIVE_CLASS = 'is-miraclas-card-fade-active';
const READY_CLASS = 'is-miraclas-card-fade-ready';
const INTERVAL_MS = 5000;

function setActiveImage(images, index) {
	images.forEach(function (img, i) {
		img.classList.toggle(ACTIVE_CLASS, i === index);
	});
}

export function initMiraclasCardFade() {
	const containers = document.querySelectorAll(CONTAINER_SELECTOR);
	if (!containers.length) return;

	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	containers.forEach(function (container) {
		const images = container.querySelectorAll(IMG_SELECTOR);
		if (!images.length) return;

		setActiveImage(images, 0);
		container.classList.add(READY_CLASS);

		if (images.length <= 1 || reducedMotion) return;

		let index = 0;

		window.setInterval(function () {
			index = (index + 1) % images.length;
			setActiveImage(images, index);
		}, INTERVAL_MS);
	});
}
